<template>
    <v-container fluid>
        <v-toolbar color="secondary" dense>
            <v-spacer></v-spacer>
            <v-toolbar-title class="white--text">Driver Shifts</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card>
            <v-form ref="form" lazy-validation>
                <v-card-actions class="pa-5">
                    <v-row justify="center">
                        <v-col cols="2">
                            <v-text-field
                                id="start_date"
                                :value="startDate"
                                required
                                label="Start Date"
                                :placeholder="$store.state.placeholder"
                                v-mask="$store.state.mask"
                                hide-details
                                :rules="$store.state.dateRules"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-text-field
                                id="end_date"
                                :value="endDate"
                                label="End Date"
                                required
                                :placeholder="$store.state.placeholder"
                                v-mask="$store.state.mask"
                                hide-details
                                :rules="$store.state.dateRules"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-combobox
                                label="Select Driver"
                                outlined
                                filled
                                class="mt-3"
                                dense
                                hide-details
                                :items="drivers"
                                :item-text="'Name'"
                                :item-value="'id'"
                                auto-select-first
                                v-model="driver"
                            ></v-combobox>
                        </v-col>
                        <v-col cols="4">
                            <v-btn
                                color="secondary"
                                class="mt-4 mr-6"
                                dense
                                @click="shiftTimestamps.show = true"
                                >Upload Shift Timestamps</v-btn
                            >
                            <v-btn
                                color="secondary"
                                class="mt-4 mr-6"
                                dense
                                @click="chargePayroll(null)"
                                >View Driver St</v-btn
                            >
                            <v-col cols="2">
                                <v-text-field
                                    label="Search Invoice"
                                    v-model="invId"
                                    v-on:keyup.enter="searchInvoice"
                                    hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2"></v-col>
                            <div v-if="details">
                                <v-text-field
                                    label="Invoice Date"
                                    v-model="InvDate"
                                    class="float-left mt-5"
                                    dense
                                    hide-details
                                    :placeholder="$store.state.placeholder"
                                    v-mask="$store.state.mask"
                                    :rules="$store.state.dateRules"
                                ></v-text-field>
                                <v-btn
                                    color="#005187"
                                    icon
                                    @click="createInvoice"
                                    x-large
                                    class="float-left  ml-12"
                                    ><v-icon>mdi-note-plus-outline</v-icon>
                                    Invoice</v-btn
                                >
                            </div>
                        </v-col>
                        <v-col></v-col>
                    </v-row>
                </v-card-actions>
            </v-form>
        </v-card>
        <v-card class="mt-3" v-if="details">
            <v-toolbar color="secondary" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text"
                    >Driver Statement Details</v-toolbar-title
                >
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container fluid>
                <v-row>
                    <v-col cols="2">
                        <v-combobox
                            v-model="invoice"
                            label="Select Invoice"
                            :items="invoices"
                            required
                            auto-select-first
                            hide-details
                            dense
                            @change="showInvoice()"
                        ></v-combobox>
                    </v-col>
                    <v-col>
                        <v-btn
                            color="primary"
                            v-if="details"
                            icon
                            @click="printDriversPayroll(null)"
                            x-large
                            class="ml-3 mr-3"
                            ><v-icon>mdi-printer</v-icon></v-btn
                        >
                        <v-btn
                            color="primary"
                            v-if="details"
                            icon
                            @click="printDriversPayrollHST(1)"
                            x-large
                            class="ml-3"
                            ><v-icon>mdi-printer</v-icon> HST</v-btn
                        >
                        <v-btn color="success" @click="ExcelReport" class="mx-6"
                            ><v-icon>mdi-microsoft-excel</v-icon> Download
                        </v-btn>
                        <v-btn
                            color="red"
                            dark
                            @click="confirmDeleteInvoice"
                            class="mr-10 float-right"
                            ><v-icon>mdi-delete-empty</v-icon> Invoice</v-btn
                        >
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <table
                            dense
                            style="overflow: scroll;overflow: auto; width: 100%;"
                        >
                            <thead>
                                <tr>
                                    <th>Shift Detail</th>
                                    <th>Date</th>
                                    <th>Shift</th>
                                    <th>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <p
                                                
                                                style="margin: 0px;padding: 0px;"
                                                v-bind="attrs"
                                                v-on="on">
                                                DT
                                                </p>
                                            </template>
                                            <span>Driver Training</span>
                                        </v-tooltip>
                                    </th>
                                    <th>Driver</th>
                                    <th>Truck</th>
                                    <th> <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <p
                                                style="margin: 0px;padding: 0px;"
                                                v-bind="attrs"
                                                v-on="on">
                                                RU
                                                </p>
                                            </template>
                                            <span>Replacement Unit</span>
                                        </v-tooltip></th>
                                    <th style="background-color: #B39DDB;">
                                        GPSStart
                                    </th>
                                    <th style="background-color: #B39DDB;">
                                        GPSEnd
                                    </th>
                                    <th style="background-color: #B39DDB;">
                                        GPSHrs
                                    </th>
                                    <th style="background-color: #FFCCBC;">
                                        LogStart
                                    </th>
                                    <th style="background-color: #FFCCBC;">
                                        LogEnd
                                    </th>
                                    <th
                                        style="background-color: #FFCCBC;"
                                        width="1.5%"
                                    >
                                        TimeOff
                                    </th>
                                    <!-- <th style="background-color: #FFCCBC;">LOGHrs</th> -->
                                    <th style="background-color: #FFCCBC;">
                                        PreTrip
                                    </th>
                                    <th style="background-color: #FFCCBC;">
                                        PosTrip
                                    </th>

                                    <th style="background-color: #B39DDB;">
                                        Total GPS
                                    </th>
                                    <th style="background-color: #FFCCBC;">
                                        Total Elog
                                    </th>
                                    <th style="background-color: #FFFDE7;">
                                        Diff (hrs)
                                    </th>

                                    <th style="background-color: #E8F5E9;">
                                        StartTime
                                    </th>
                                    <th style="background-color: #E8F5E9;">
                                        EndTime
                                    </th>
                                    <th style="background-color: #E8F5E9;">
                                        Hours
                                    </th>
                                    <th style="background-color: #E8F5E9;">
                                        Rate
                                    </th>
                                    <th style="background-color: #E8F5E9;">
                                        Hourly Pay
                                    </th>
                                    <th style="background-color: #E8F5E9;">
                                        ExtHours
                                    </th>
                                    <th style="background-color: #E8F5E9;">
                                        ExtAmount
                                    </th>
                                    <th style="background-color: #E8F5E9;">
                                        Invoice
                                    </th>
                                    <th style="background-color: #E8F5E9;">
                                        Print
                                    </th>
                                    <!-- <th style="background-color: #E8F5E9;">Driver Type</th>
                                    <th style="background-color: #E8F5E9;">TripRate</th>
                                    <th style="background-color: #E8F5E9;">ShiftPay</th> -->
                                </tr>
                            </thead>
                            <tbody
                                v-for="(itm, idx) in filteredItems"
                                v-bind:key="idx"
                            >
                                <template>
                                    <tr
                                        class="text-center"
                                        @contextmenu.prevent="
                                            $refs.menuGo.open($event, itm)
                                        "
                                    >
                                        <td
                                            @click="showRow(itm)"
                                            style="background-color: #E3F2FD;border: 1px solid blue;"
                                            class="py-1"
                                        >
                                            {{ itm.ShiftDetail }}
                                        </td>
                                        <td style="background-color: #E3F2FD;">
                                            {{ itm.Date }}
                                        </td>
                                        <td style="background-color: #E3F2FD;">
                                            {{ itm.Shift }}
                                        </td>
                                        <td style="background-color: #E3F2FD;">
                                            {{ itm.Trainig }}
                                        </td>
                                        <td
                                            style="background-color: #E3F2FD;"
                                            @click="
                                                getDailySummary(itm.ShiftDetail)
                                            "
                                        >
                                            {{ itm.Name }}
                                        </td>
                                        <td style="background-color: #E3F2FD;">
                                            {{ itm.Truck }}
                                        </td>
                                        <td style="background-color: #E3F2FD;">
                                            {{ itm.ReplacementUnit }}
                                        </td>
                                        <td
                                            :style="
                                                itm.GPSShiftStartOrigin == 2
                                                    ? 'border-bottom: 1px solid #777;background-color: #80D8A6;'
                                                    : itm.GPSShiftStartOrigin ==
                                                      3
                                                    ? 'border-bottom: 1px solid #777;background-color: #80D8D5;'
                                                    : itm.GPSShiftStartOrigin ==
                                                      4
                                                    ? 'border-bottom: 1px solid #777;background-color: #eff93f;'
                                                    : 'border-bottom: 1px solid #777;'
                                            "
                                        >
                                            <p
                                                v-show="itm.ShowGPSShiftStart"
                                                v-if="
                                                    itm.GPSShiftStart != '' &&
                                                        itm.GPSShiftStart !=
                                                            null &&
                                                        itm.GPSShiftStart !=
                                                            undefined
                                                "
                                                @click="
                                                    itm.ShowGPSShiftStart = false
                                                "
                                                style="margin: 0;font-size: 13px;"
                                            >
                                                {{ itm.GPSShiftStartDate }}
                                                <strong class="timeShiftValue">
                                                    {{ itm.GPSShiftStartTime }}
                                                </strong>
                                            </p>
                                            <p
                                                v-else
                                                @click="
                                                    itm.ShowGPSShiftStart = false
                                                "
                                                class="replicateShiftPlaceholder"
                                            >
                                                YYYY-MM-DD HH:MM
                                            </p>

                                            <p
                                                id="divs"
                                                width="20%"
                                                v-show="!itm.ShowGPSShiftStart"
                                            >
                                                <v-text-field
                                                    autofocus
                                                    placeholder="YYYY-MM-DD HH:MM"
                                                    v-mask="'####-##-## ##:##'"
                                                    type="tel"
                                                    id="GPSShiftStart"
                                                    v-model="itm.GPSShiftStart"
                                                    dense
                                                    @change="
                                                        saveShiftDetails(itm, 1)
                                                    "
                                                    @blur="
                                                        itm.ShowGPSShiftStart = true
                                                    "
                                                    hide-details
                                                ></v-text-field>
                                            </p>
                                        </td>
                                        <td
                                            :style="
                                                itm.GPSShiftEndOrigin == 2
                                                    ? 'border-bottom: 1px solid #777;background-color: #80D8A6;'
                                                    : itm.GPSShiftEndOrigin == 3
                                                    ? 'border-bottom: 1px solid #777;background-color: #80D8D5;'
                                                    : itm.GPSShiftEndOrigin == 4
                                                    ? 'border-bottom: 1px solid #777;background-color: #eff93f;'
                                                    : 'border-bottom: 1px solid #777;'
                                            "
                                        >
                                            <p
                                                v-show="itm.ShowGPSShiftEnd"
                                                v-if="
                                                    itm.GPSShiftEnd != '' &&
                                                        itm.GPSShiftEnd !=
                                                            null &&
                                                        itm.GPSShiftEnd !=
                                                            undefined
                                                "
                                                @click="
                                                    itm.ShowGPSShiftEnd = false
                                                "
                                                style="margin: 0;font-size: 13px;"
                                            >
                                                {{ itm.GPSShiftEndDate }}
                                                <strong class="timeShiftValue">
                                                    {{ itm.GPSShiftEndTime }}
                                                </strong>
                                            </p>
                                            <p
                                                v-else
                                                @click="
                                                    itm.ShowGPSShiftEnd = false
                                                "
                                                class="replicateShiftPlaceholder"
                                            >
                                                YYYY-MM-DD HH:MM
                                            </p>

                                            <p
                                                width="20%"
                                                v-show="!itm.ShowGPSShiftEnd"
                                            >
                                                <v-text-field
                                                    autofocus
                                                    placeholder="YYYY-MM-DD HH:MM"
                                                    v-mask="'####-##-## ##:##'"
                                                    type="tel"
                                                    id="GPSShiftEnd"
                                                    v-model="itm.GPSShiftEnd"
                                                    hide-details
                                                    dense
                                                    @change="
                                                        saveShiftDetails(itm, 1)
                                                    "
                                                    @blur="
                                                        itm.ShowGPSShiftEnd = true
                                                    "
                                                ></v-text-field>
                                            </p>
                                        </td>
                                        <td style="background-color: #E3F2FD;">
                                            {{ itm.GPSHrs }}
                                        </td>
                                        <td style="background-color: #E3F2FD;">
                                            {{ itm.ShiftStartTime }}
                                        </td>
                                        <td style="background-color: #E3F2FD;">
                                            {{ itm.ShiftEndTime }}
                                        </td>

                                        <td style="background-color: #E3F2FD;">
                                            <input
                                                type="text"
                                                v-model="itm.TimeOff"
                                                @change="saveTimeOff(itm)"
                                                @input="timeOff(itm)"
                                                class="text-center"
                                                style="height: 100%; width: 100%;"
                                            />
                                        </td>

                                        <!-- <td style="background-color: #E3F2FD;">{{ itm.LOGHrs }}</td> -->
                                        <td style="background-color: #E3F2FD;">
                                            {{ itm.PreTrip }}
                                        </td>
                                        <td style="background-color: #E3F2FD;">
                                            {{ itm.PostTrip }}
                                        </td>

                                        <td style="background-color: #E3F2FD;">
                                            {{ itm.TotalGps }}
                                        </td>
                                        <td style="background-color: #E3F2FD;">
                                            {{ itm.TotalElog }}
                                        </td>
                                        <td style="background-color: #E3F2FD;">
                                            {{ itm.Diff }}
                                        </td>

                                        <td style="background-color: #E3F2FD;">
                                            {{
                                                itm.Posting == true
                                                    ? itm.ShiftStartTime
                                                    : null
                                            }}
                                        </td>
                                        <td style="background-color: #E3F2FD;">
                                            {{
                                                itm.Posting == true
                                                    ? itm.ShiftEndTime
                                                    : null
                                            }}
                                        </td>
                                        <td style="background-color: #E3F2FD;">
                                            {{ itm.TotalHours }}
                                        </td>
                                        <td style="background-color: #E3F2FD;">
                                            {{ itm.Rate }}
                                        </td>
                                        <td style="background-color: #E3F2FD;">
                                            {{ itm.HrlyPay }}
                                        </td>
                                        <td style="background-color: #E3F2FD;">
                                            {{ itm.TotalQuantity }}
                                        </td>
                                        <td style="background-color: #E3F2FD;">
                                            {{ itm.TotalAmount }}
                                        </td>
                                        <td style="background-color: #E3F2FD;">
                                            {{ itm.DrivInv }}
                                        </td>
                                        <td style="background-color: #E3F2FD;">
                                            <v-checkbox
                                                @change="changePrint(itm)"
                                                v-model="itm.Print"
                                                dense
                                                hide-details
                                            ></v-checkbox>
                                        </td>

                                        <!-- <td style="background-color: #E3F2FD;">{{ itm.DriverType }}</td>
                                        <td style="background-color: #E3F2FD;">{{ itm.TripRate }}</td>
                                        <td style="background-color: #E3F2FD;">{{ itm.ShiftPay }}</td> -->
                                    </tr>
                                    <tr
                                        v-show="itm.ShowRow"
                                        class="text-center"
                                    >
                                        <td
                                            style="background-color: #E8EAF6;"
                                            colspan="3"
                                        >
                                            Shift GPSComments
                                        </td>
                                        <td style="background-color: #E8EAF6;">
                                            Order
                                        </td>
                                        <td style="background-color: #E8EAF6;">
                                            Terminal Start
                                        </td>
                                        <td style="background-color: #E8EAF6;">
                                            Terminal End
                                        </td>
                                        <td style="background-color: #E8EAF6;">
                                            Diff
                                        </td>
                                        <td style="background-color: #E8EAF6;">
                                            Station Start
                                        </td>
                                        <td style="background-color: #E8EAF6;">
                                            Station End
                                        </td>
                                        <td style="background-color: #E8EAF6;">
                                            Diff
                                        </td>
                                        <td
                                            style="background-color: #E8EAF6;"
                                            colspan="2"
                                        >
                                            Terminal
                                        </td>
                                        <td
                                            style="background-color: #E8EAF6;"
                                            colspan="2"
                                        >
                                            Station
                                        </td>
                                        <td
                                            style="background-color: #E8EAF6;"
                                            colspan="6"
                                        >
                                            Comment
                                        </td>
                                        <td style="background-color: #E8EAF6;">
                                            ExtHour
                                        </td>
                                        <td style="background-color: #E8EAF6;">
                                            ExtAmount
                                        </td>
                                    </tr>
                                    <tr
                                        v-for="(it, id) in itm.orders"
                                        v-bind:key="it.OrderID"
                                        v-show="itm.ShowRow"
                                        class="text-center"
                                    >
                                        <td
                                            style="background-color: #eee;"
                                            colspan="3"
                                            :rowspan="itm.orders.length"
                                            v-if="id == 0"
                                        >
                                            <textarea
                                                type="text"
                                                v-model="itm.GPSComments"
                                                @change="
                                                    saveShiftDetails(itm, 0)
                                                "
                                                class="text-justify"
                                                style="height: 100%; width: 100%;"
                                            ></textarea>
                                        </td>
                                        <td style="background-color: #eee;">
                                            {{ it.OrderID }}
                                        </td>
                                        <td style="background-color: #eee;">
                                            {{ it.TStart }}
                                        </td>
                                        <td style="background-color: #eee;">
                                            {{ it.TEnd }}
                                        </td>
                                        <td style="background-color: #eee;">
                                            {{ it.DiffT }}
                                        </td>
                                        <td style="background-color: #eee;">
                                            {{ it.StStart }}
                                        </td>
                                        <td style="background-color: #eee;">
                                            {{ it.StEnd }}
                                        </td>
                                        <td style="background-color: #eee;">
                                            {{ it.DiffSt }}
                                        </td>
                                        <td
                                            style="background-color: #eee;"
                                            colspan="2"
                                        >
                                            {{ it.TerminalName }}
                                        </td>
                                        <td
                                            style="background-color: #eee;"
                                            colspan="2"
                                        >
                                            {{ it.Station }}
                                        </td>
                                        <td
                                            style="background-color: #eee;"
                                            colspan="6"
                                        >
                                            <textarea
                                                type="text"
                                                v-model="it.GPSComments"
                                                class="text-justify"
                                                @change="saveOrderCommnet(it)"
                                                style="height: 100%; width: 100%;"
                                            ></textarea>
                                        </td>
                                        <td style="background-color: #eee;">
                                            {{ it.TotalQuantity }}
                                        </td>
                                        <td style="background-color: #eee;">
                                            {{ it.TotalAmount }}
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                            <tr>
                                <td colspan="17"></td>
                                <td
                                    style="text-align: right;background-color: #E3F2FD;"
                                >
                                    <strong>Total</strong>
                                </td>
                                <td
                                    colspan="1"
                                    style="text-align: center;background-color: #E3F2FD;"
                                >
                                    <strong>{{
                                        Number(
                                            calculateTotal(
                                                'TotalHours',
                                                filteredItems
                                            )
                                        ).toFixed(2)
                                    }}</strong>
                                </td>
                                <td
                                    colspan="1"
                                    style="text-align: center;background-color: #E3F2FD;"
                                ></td>
                                <td
                                    colspan="1"
                                    style="text-align: center;background-color: #E3F2FD;"
                                >
                                    <strong>{{
                                        Number(totalPay).toFixed(2)
                                    }}</strong>
                                </td>
                                <td
                                    colspan="1"
                                    style="text-align: center;background-color: #E3F2FD;"
                                >
                                    <strong>{{
                                        Number(
                                            calculateTotal(
                                                'TotalQuantity',
                                                filteredItems
                                            )
                                        ).toFixed(2)
                                    }}</strong>
                                </td>
                                <td
                                    colspan="1"
                                    style="text-align: center;background-color: #E3F2FD;"
                                >
                                    <strong>{{
                                        Number(
                                            calculateTotal(
                                                'TotalAmount',
                                                filteredItems
                                            )
                                        ).toFixed(2)
                                    }}</strong>
                                </td>
                                <td
                                    colspan="3"
                                    style="text-align: center;background-color: #E3F2FD;"
                                ></td>
                            </tr>
                        </table>
                    </v-col>
                </v-row>
            </v-container>
            <v-divider></v-divider>
        </v-card>

        <div class="text-center">
            <v-dialog v-model="dialog" persistent width="400">
                <v-card color="primary" dark>
                    <v-card-text class="text-center">
                        <v-col cols="12">
                            <v-progress-circular
                                class="mt-5"
                                :size="90"
                                indeterminate
                            ></v-progress-circular>
                        </v-col>
                        <v-col>
                            Loading...
                        </v-col>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
        <vue-context ref="menuGo" dense>
            <template slot-scope="selected" v-if="selected.data">
                <li>
                    <a @click="openPosting(selected.data)">Posting</a>
                </li>
            </template>
        </vue-context>

        <DailySummary
            v-if="$store.state.paperworkAnalytics.DailySummay"
            :OrderToCheck="DailySum"
        ></DailySummary>

        <posting
            v-if="$store.state.driverHrly.posting"
            :searchShift="shift"
            @close="chargePayroll(null)"
        ></posting>

        <v-dialog v-model="shiftTimestamps.show" max-width="1500px" persistent>
            <v-card>
                <v-card-title style="padding: 30px;">
                    <span class="headline">Import Shift Timestamps</span>
                    <v-spacer></v-spacer>
                    <v-btn
                        outlined
                        style="margin-left: 20px;"
                        icon
                        left
                        @click="shiftTimestamps.show = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-card outlined class="mb-4">
                        <v-card-text>
                            <v-file-input
                                v-model="shiftTimestamps.files"
                                label="Select files"
                                prepend-icon="mdi-paperclip"
                                multiple
                            ></v-file-input>
                        </v-card-text>
                    </v-card>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="shiftTimestamps.show = false"
                            >Cancel</v-btn
                        >
                        <v-btn
                            color="blue darken-1"
                            outlined
                            @click="uploadShiftTimestamps"
                            >Submit files</v-btn
                        >
                    </v-card-actions>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import ConfirmDialogue from './../Modals/ConfirmDialogue.vue';
import posting from './../Modals/Administration/DriverShifts/PostingModal.vue';
import { mask } from 'vue-the-mask';
import DailySummary from '../Paperwork/DailySummary.vue';
import VueContext from 'vue-context';
import axios from 'axios';
export default {
    name: 'PayrollHrly',
    directives: { mask },
    components: { ConfirmDialogue, VueContext, posting, DailySummary },
    data: function() {
        return {
            startDate: '',
            endDate: '',
            shift: null,
            InvDate: null,
            headerProducts: [
                { text: 'Shift Detail', value: 'ShiftDetail', width: '5%' },
                { text: 'Date', value: 'Date', width: '8%' },
                { text: 'Driver', value: 'Name', width: '10%' },
                { text: 'Truck', value: 'Truck', width: '5%' },
                { text: 'GPSShiftStart', value: 'GPSShiftStart', width: '10%' },
                { text: 'GPSShiftEnd', value: 'GPSShiftEnd', width: '10%' },
                { text: 'GPSHrs', value: 'GPSHrs', width: '1%' },
                { text: 'LogStart', value: 'LogStart', width: '10%' },
                { text: 'LogEnd', value: 'LogEnd', width: '5%' },
                { text: 'LOGHrs', value: 'LOGHrs', width: '1%' },
                { text: 'Start Time', value: 'ShiftStartTime', width: '10%' },
                { text: 'End Time', value: 'ShiftEndTime', width: '10%' },
                { text: 'Hours', value: 'TotalHours', width: '5%' },
                { text: 'Rate', value: 'Rate', width: '1%' },
                { text: 'Hourly Pay', value: 'HrlyPay', width: '10%' },
                { text: 'Driver Type', value: 'DriverType', width: '1%' },
                { text: 'Trip Rate', value: 'TripRate', width: '5%' },
                { text: 'ShiftPay', value: 'ShiftPay', width: '10%' }
            ],
            dateRules: [
                v => !!v || 'This date is required',
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect'
            ],
            totalPay: 0,
            start_date: '',
            end_date: '',
            valid: true,
            details: false,
            drivers: [],
            driver: [],
            dialog: false,
            driverStatement: [],
            invoices: [],
            invoice: null,
            DailySum: null,
            modified: null,
            shiftTimestamps: {
                show: false,
                files: []
            },
            invId: null,
            printTimeout: null,
            printStatuses: []
        };
    },
    mounted() {
        this.loadDrivers();
    },
    computed: {
        filteredItems() {
            return this.driverStatement.filter(i => {
                if (this.invoice == i.DrivInv) {
                    return this.invoice == i.DrivInv;
                } else if (this.invoice === null) {
                    return i;
                }
            });
        }
    },
    methods: {
        changePrint(item) {
            this.printStatuses.push(item);
            clearTimeout(this.printTimeout); // Clear previous timeout
            this.printTimeout = setTimeout(() => {
                this.sendPrintStatuses();
            }, 3000);
        },
        sendPrintStatuses() {
            console.log(this.printStatuses);
            let data = this.printStatuses.map(shift => {
                return { ShiftDetail: shift.ShiftDetail, Print: shift.Print };
            });
            let params = { data };
            console.log('Params: ', params);

            axios
                .post('shift-detail/update/print-statuses', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    this.printStatuses = [];
                    this.chargePayroll(null, false);
                })
                .catch(error => {
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'An error has ocurred, please try again.'
                    });
                    console.log(error);
                });
        },
        calculateTotal(field, source) {
            return source.reduce((acc, item) => acc + Number(item[field]), 0);
        },
        openPosting: function(itm) {
            this.shift = itm.ShiftDetail;
            console.log(itm);
            this.$store.state.driverHrly.posting = true;
        },
        timeOff: async function(itm) {
            console.log(itm.timeOff, itm.timeOffst);
            itm.TotalElog = await Number((itm.LOGHrs - itm.TimeOff).toFixed(2));
            itm.Diff = Number((itm.TotalElog - itm.TotalGps).toFixed(2));
            console.log(itm.TotalElog);
        },
        async saveTimeOff(itm) {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to save TimeOff :' + itm.TimeOff,
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                var str = this.$store;
                var parms = {
                    TimeOff: itm.TimeOff
                };
                axios
                    .put('shift-detail/time-off/' + itm.ShiftDetail, parms, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    // eslint-disable-next-line no-unused-vars
                    .then(response => {
                        str.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'Edit Assignment successifly'
                        });
                        this.chargePayroll(null);
                        this.$store.state.posting.watch = true;
                        this.$store.state.transacting.watch = true;
                        this.$store.state.assignment.dialog = false;
                    })
                    .catch(function(error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
            }
        },
        loadDrivers: function() {
            axios
                .get('driver/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.drivers = response.data.data;
                    console.log(this.drivers);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        deleteDuplicate: function(arr) {
            const resultado = [];
            for (const elemento of arr) {
                if (!resultado.includes(elemento)) {
                    resultado.push(elemento);
                }
            }
            return resultado;
        },
        uploadShiftTimestamps: function() {
            console.log('uploadShiftTimestamps');
            // Handle file submission logic here
            console.log('Files submitted:', this.shiftTimestamps.files);

            if (!this.shiftTimestamps.files.length) {
                this.$store.dispatch('setSnackbar', {
                    text: 'You have to upload at least 1 file.',
                    color: 'error'
                });
                return;
            }

            if (this.shiftTimestamps.files.length == 50) {
                this.$store.dispatch('setSnackbar', {
                    text: 'You can upload up to 50 files.',
                    color: 'error'
                });
                return;
            }

            const str = this.$store;
            const formData = new FormData();
            for (let file of this.shiftTimestamps.files) {
                formData.append('files[]', file);
            }

            console.log('params', formData);
            str.state.isLoading = true;
            axios
                .post('/payroll/upload/shift-timestamps', formData, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token,
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    console.log('response: ', response.data);
                    str.state.isLoading = false;
                    this.shiftTimestamps.show = false;
                    this.shiftTimestamps.files = [];
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Correct loading and updating of file data'
                    });
                })
                .catch(error => {
                    console.log(error);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'Something went wrong, contact the administrator'
                    });
                });
        },
        chargePayroll: function(recall, dialog = true) {
            this.dialog = dialog;
            var data = {
                StartDate: this.$store.state.getMsk('start_date'),
                EndDate: this.$store.state.getMsk('end_date'),
                Driver: this.driver['id']
            };

            var str = this.$store;

            console.log(data);
            axios
                .post('payroll/hourly', data, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    this.driverStatement = response.data.shifts;
                    this.driverStatement.forEach(element => {
                        element.TimeOffset = element.TimeOff;
                    });
                    const payHrl = this.driverStatement.map(x => {
                        return x.HrlyPay;
                    });
                    const sum = payHrl.reduce(
                        (total, valor) => total + valor,
                        0
                    );
                    this.totalPay = sum;
                    const duplicate = this.driverStatement.map(x => {
                        return x.DrivInv;
                    });

                    this.invoices = await this.deleteDuplicate(duplicate);
                    this.invoice = this.invoices[0];
                    console.log(this.invoices);
                    this.details = true;
                    this.dialog = false;
                    console.log(this.driverStatement);
                    if (recall != null) {
                        this.invoice = recall;
                    }
                })
                .catch(function(error) {
                    console.log(error);

                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        showRow: function(row) {
            row.ShowRow = !row.ShowRow;

            console.log(row.ShowRow);
        },
        LoadShifts: function() {
            const shifts = this.driverStatement
                .filter(x => {
                    return x.DrivInv === 0;
                })
                .map(x => {
                    return x.ShiftDetail;
                });
            console.log(shifts);
        },
        ExcelReport: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            var data = {
                StartDate: this.$store.state.getMsk('start_date'),
                EndDate: this.$store.state.getMsk('end_date'),
                Driver: this.driver['id'],
                Excel: 1,
                Export: 0
            };
            axios
                .post('payroll/hourly', data, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        'download',
                        this.driver.Name +
                            '  ' +
                            this.$store.state.getMsk('start_date') +
                            '/' +
                            this.$store.state.getMsk('end_date') +
                            '.xlsx'
                    );
                    document.body.appendChild(link);
                    link.click();

                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    str.state.isLoading = false;
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        printDriversPayrollHST: function(type) {
            var str = this.$store;
            var data = {
                StartDate: this.$store.state.getMsk('start_date'),
                EndDate: this.$store.state.getMsk('end_date'),
                Driver: this.driver['id'],
                Export: 1,
                HST: type,
                DrivInv: this.invoice
            };
            console.log(data);
            if (this.invoice == 0 || this.invoice === null) {
                str.dispatch('setSnackbar', {
                    color: 'red',
                    text: 'Invalid invoice number'
                });
            } else {
                this.$store.state.isLoading = true;
                axios
                    .post('payroll/hourly/invoice/pdf', data, {
                        responseType: 'blob',
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        const url = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Drivers-Payroll.pdf');
                        document.body.appendChild(link);
                        link.click();

                        this.$store.state.isLoading = false;
                    })
                    .catch(function(error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
            }
        },
        getMsk: function(id) {
            return document.getElementById(id).value;
        },
        saveShiftDetails: function(itm, isDate) {
            this.$store.state.isLoading = true;
            //   const delay = ms => new Promise(res => setTimeout(res, ms));
            //   let index = this.indexDriver;
            var str = this.$store;
            var params = {
                GPSShiftStart: itm.GPSShiftStart,
                GPSShiftEnd: itm.GPSShiftEnd,
                GPSComments: itm.GPSComments,
                Print: itm.Print
            };
            if (isDate) {
                params.GPSShiftStartOrigin = 3;
                params.GPSShiftEndOrigin = 3;
            }

            console.log(params);
            axios
                .put('shift-detail/' + itm.ShiftDetail, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(async response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Shift GPSComment Successfully updated.'
                    });
                    console.log(response.data);
                    this.chargePayroll(null, false);

                    str.state.isLoading = false;
                })
                .catch(error => {
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'An error has ocurred, please try again.'
                    });
                    str.state.isLoading = false;
                    console.log(error);
                });
        },
        saveOrderCommnet: function(order) {
            var str = this.$store;
            str.state.isLoading = true;
            var params = {
                'GPS Comments': order.GPSComments
            };
            axios
                .put('order/' + order.OrderID, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(async response => {
                    console.log('Response', response.data);

                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Comment Save'
                    });
                    str.state.isLoading = false;
                })
                .catch(error => {
                    str.state.isLoading = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    console.log(error);
                });
        },
        showInvoice: function() {
            console.log(this.invoice);
        },
        createInvoice: function() {
            var str = this.$store;
            if (this.InvDate != null) {
                str.state.isLoading = true;
                var params = {
                    StartDate: this.$store.state.getMsk('start_date'),
                    EndDate: this.$store.state.getMsk('end_date'),
                    Driver: this.driver['id'],
                    InvDate: this.InvDate
                };
                axios
                    .post('payroll/hourly/invoice/create', params, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    // eslint-disable-next-line no-unused-vars
                    .then(async response => {
                        console.log('Response', response.data);

                        str.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'Create Invoice'
                        });
                        str.state.isLoading = false;
                        this.chargePayroll(response.data.DrivInvID);
                    })
                    .catch(error => {
                        str.state.isLoading = false;
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                        console.log(error);
                    });
            } else {
                str.dispatch('setSnackbar', {
                    color: 'red',
                    text: 'Enter an invoice date to continue'
                });
            }
        },
        printDriversPayroll: function(type) {
            var str = this.$store;
            this.$store.state.isLoading = true;
            var data = {
                StartDate: this.$store.state.getMsk('start_date'),
                EndDate: this.$store.state.getMsk('end_date'),
                Driver: this.driver['id'],
                Export: 1,
                HST: type
            };
            axios
                .post('payroll/hourly', data, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Drivers-Payroll.pdf');
                    document.body.appendChild(link);
                    link.click();

                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        async confirmDeleteInvoice() {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to delete this Invoice',
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.deleteInvoice();
            }
        },
        getDailySummary: function(order) {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .get('order/document/daily-summary/' + order, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.DailySum = response.data;
                    if (this.DailySum.length > 0) {
                        this.$store.state.paperworkAnalytics.DailySummay = true;
                    } else {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'DailySummary not found.'
                        });
                    }
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                    str.state.isLoading = false;
                });
        },
        deleteInvoice: function() {
            var str = this.$store;
            var params = {
                DrivInv: this.invoice
            };
            if (this.invoice == 0 || this.invoice === null) {
                str.dispatch('setSnackbar', {
                    color: 'red',
                    text: 'Invalid invoice number'
                });
            } else {
                str.state.isLoading = true;
                axios
                    .post('payroll/hourly/invoice/remove', params, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    // eslint-disable-next-line no-unused-vars
                    .then(async response => {
                        console.log('Response', response.data);

                        str.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'Create Invoice'
                        });
                        str.state.isLoading = false;
                        this.chargePayroll(response.data.DrivInvID);
                    })
                    .catch(error => {
                        str.state.isLoading = false;
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                        console.log(error);
                    });
            }
        },
        searchInvoice: function() {
            var str = this.$store;
            axios
                .get('payroll/driver-invoice/' + this.invId, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    this.startDate = response.data.StartDate;
                    this.endDate = response.data.EndDate;
                    const idx = await this.drivers.findIndex(x => {
                        return x.id == response.data.Driver;
                    });
                    this.driver = this.drivers[idx];
                    this.chargePayroll(null);
                    console.log(response.data);
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'Invoice not found.'
                        });
                    }
                    if (error.response.status === 404) {
                        this.startDate = null;
                        this.endDate = null;
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        }

    }
};
</script>

<style scoped>
@import '~vue-context/dist/css/vue-context.css';
    thead th {
      background-color: #f4f4f4;
      position: sticky;
      top: 0; /* Fija el encabezado al inicio */
      z-index: 1; /* Asegura que esté por encima de las celdas */
    }
</style>
